var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-services"},[_c('event-service-tabs',{attrs:{"tab":_vm.serviceTab}}),_c(_vm.component,_vm._b({tag:"component"},'component',_vm.payload,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }